import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import { LoadingButton as Button, Select } from "@aclymatepackages/atoms";
import FeatureErrorBoundary from "../../atoms/FeatureErrorBoundary";

import CompanyLayout from "../../layouts/CompanyLayout";
import Dashboard from "../dashboard";
import Settings from "../settings";
import Purchase from "../purchase";
import Badges from "../badges";
import Reporting from "../reporting";
import Accounting from "../accounting";
import Events from "../events";
import Products from "../products";

import { StripeCustomerContextProvider } from "../../../helpers/contexts/stripeCustomer";
import { SimulationContextProvider } from "../../../helpers/contexts/simulation";
import AccountAccessLayout from "../../layouts/AccountAccessLayout";
const PageSwitch = () => {
  const { page, view } = useParams();

  const companyPageComponents = (page) => {
    switch (page) {
      case "dashboard":
        return <Dashboard />;
      case "settings":
        return <Settings view={view} />;
      case "purchase":
        return <Purchase />;
      case "badges":
        return <Badges />;
      case "reporting":
        return <Reporting />;
      case "accounting":
        return <Accounting />;
      case "events":
        return <Events />;
      case "products":
        return <Products />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <CompanyLayout page={page} view={view}>
      <FeatureErrorBoundary featureName="Simulation">
        {companyPageComponents(page)}
      </FeatureErrorBoundary>
    </CompanyLayout>
  );
};

const simulationCompanies = [
  { id: "promo", name: "Promo Company" },
  { id: "brightstone", name: "Brightstone Food Manufacturing" },
  { id: "ridgeway", name: "Ridgeway Manufacturing Co." }
];

const SimulationIndex = () => {
  const [companyId, setCompanyId] = useState("");
  const { companyName, page } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (companyName && !page) {
      const company = simulationCompanies.find((c) => c.id === companyName);
      if (company) {
        history.replace(`/simulation/${company.id}/dashboard`);
        return;
      }
    }

    if (companyName && !companyId) {
      setCompanyId(companyName);
      return;
    }

    if (companyId) {
      sessionStorage.setItem("accountId", companyId);
      localStorage.setItem("accountCollection", "v3-companies");
    }
  }, [companyName, companyId, page, history]);

  const handleContinue = () => {
    history.push(`/simulation/${companyId}/dashboard`);
  };

  if (!companyName) {
    return (
      <AccountAccessLayout
        formTitle="Welcome to the Aclymate Simulator!"
        formSubtitle="Select one of the companies to understand how Aclymate works"
        layoutType="login"
      >
        <Select
          label="Select a Company"
          options={simulationCompanies.map((company) => ({
            label: company.name,
            value: company.id
          }))}
          value={companyId}
          editValue={setCompanyId}
          size="small"
        />

        <Button
          label="continue"
          variant="contained"
          color="primary"
          disabled={!companyId}
          onClick={handleContinue}
        />
      </AccountAccessLayout>
    );
  }

  return (
    <FeatureErrorBoundary featureName="Simulation">
      <SimulationContextProvider>
        <StripeCustomerContextProvider>
          <PageSwitch />
        </StripeCustomerContextProvider>
      </SimulationContextProvider>
    </FeatureErrorBoundary>
  );
};

export default SimulationIndex;
